import React from 'react'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import Loader from '../Loader';
import ErrorAlert from '../ErrorAlert';
import { useGetCompaniesQuery } from '../../redux/slices/companiesSlice';
import { useGetIndustriesQuery } from '../../redux/slices/industriesSlice';



ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)


const FTEByIndustry = () => {

    const { data: industries, isLoading: isLoadingIndustries, isSuccess: isSuccessIndustries, isError: isErrorIndustries, error: errorIndustries } = useGetIndustriesQuery(undefined, {
        refetchOnMountOrArgChange: true,
    })

    const { data: companies, isLoading: isLoadingCompanies, isSuccess: isSuccessCompanies, isError: isErrorCompanies, error: errorCompanies } = useGetCompaniesQuery(undefined, {
        refetchOnMountOrArgChange: true,
    })

    let content;


    if (isLoadingIndustries || isLoadingCompanies) {
        content = (
            <Loader />
        )
    } else if (isSuccessCompanies && companies && isSuccessIndustries && industries) {

        let companiesIndustriesList: any[] = [];

        // need to get companies per industry
        companies.forEach(company => {
            company.industries.forEach(indo => {
                companiesIndustriesList.push({
                    companyId: company._id,
                    companyName: company.name,
                    employees: company.employees,
                    //@ts-ignore
                    industryId: indo.industryId._id,
                })
            })
        })

        // console.log('companiesIndustriesListWithEmployees', companiesIndustriesList);

        let merged: any[] = [];

        for (let i = 0; i < companiesIndustriesList.length; i++) {
            merged.push({
                ...companiesIndustriesList[i],
                ...(industries.find((itmInner) => itmInner._id === companiesIndustriesList[i].industryId))
            })
        }

        let sortedCompanies = merged.reduce((acc, company) => {
            const industry = acc.find(item => item.industryId === company.industryId);
            if (industry) {
                industry.companies.push(company);
            } else {
                acc.push({
                    industryId: company.industryId,
                    industryName: company.name,
                    companies: [company]
                })
            }
            return acc;
        }, [])

        // console.log('sorted companies fte', sortedCompanies);

        let fteArray = sortedCompanies.map(industry => {
            const totalEmployees = industry.companies.reduce((acc, company) => acc + company.employees, 0);
            return {
                ...industry,
                totalEmployees
            }
        })

        // console.log('fte array', fteArray.sort((a, b) => b.totalEmployees - a.totalEmployees));

        let industryLabels = fteArray.map(({ industryName }) => industryName)

        let fteData = fteArray.map(({ totalEmployees }) => totalEmployees);


        const options = {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'FTE by Industry (Top 20)',
                },
            },
        };

        const labels = [];

        const data = {
            labels: industryLabels.slice(0, 20),
            datasets: [
                {
                    label: '',
                    data: fteData.slice(0, 20),
                    backgroundColor: ['#ffc700', '#333', '#AAA'],
                },
            ],
        };



        content = (
            <Bar options={options} data={data} />
        )
    } else if (isErrorCompanies || isErrorIndustries) {
        content = (
            <ErrorAlert title="Error Loading Company Region Stats!" error={JSON.stringify(errorCompanies, null, 2)} />
        )
    } else {
        content = (
            <Loader />
        )
    }

    return content;
}

export default FTEByIndustry
